import { createAsyncThunk } from '@reduxjs/toolkit';
import OrganizationsResource from 'api/service/OrganizationsResource';
import OrganizationMembersResource from 'api/service/OrganizationMembersResource';
import UsersServiceResource from 'api/service/UsersResource';

export const listUsers = createAsyncThunk('organization/listUsers', async (initialData) => {
  const userResource = new UsersServiceResource();
  const { size = 100, search = '' } = initialData;
  const params = { size, search };
  const { status, data } = await userResource.list(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const listBrandUsers = createAsyncThunk('organization/listBrandUsers', async (initialData) => {
  const organizationResource = new OrganizationsResource();
  const { id, offset, size = 100, includes = 'organisation,admin_status', excludes } = initialData;
  const params = {
    ...(typeof offset === 'number' && { offset }),
    ...(excludes && { excludes }),
    size,
    includes,
  };

  const { status, data } = await organizationResource.organization(id).listMembers(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const listGroupUsers = createAsyncThunk('organization/listGroupUsers', async (initialData) => {
  const organizationResource = new OrganizationsResource();
  const { id, offset = 0, size = 10, includes = 'organisation' } = initialData;
  const params = {
    offset,
    size,
    includes,
  };
  const { status, data } = await organizationResource.organization(id).listMembers(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const searchOrgUsers = createAsyncThunk('organization/searchOrgUsers', async (initialData) => {
  const organizationMemberResource = new OrganizationMembersResource();
  const { search = '', organisations = '', size = 100, includes = 'organisation' } = initialData;
  const params = { search, organisations, size, includes };
  const { status, data } = await organizationMemberResource.search(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const searchGroupUsers = createAsyncThunk('organization/searchGroupUsers', async (initialData) => {
  const organizationMemberResource = new OrganizationMembersResource();
  const { search = '', organisations = '', offset = 0, size = 10, includes = 'organisation' } = initialData;
  const params = { search, organisations, offset, size, includes };
  const { status, data } = await organizationMemberResource.search(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const inviteUser = createAsyncThunk('organization/inviteUser', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { brandId, payload, includes = 'organisation' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(brandId).inviteUser(payload, params);
  if (status === 201) {
    return data;
  }
  if (status === 409) {
    return rejectWithValue('User with this email already exists.');
  }
  return rejectWithValue('Adding of user failed.');
});

export const updateUser = createAsyncThunk('organization/updateUser', async (initialData, { rejectWithValue }) => {
  const userResource = new UsersServiceResource();
  const { id, payload, includes = 'organisation' } = initialData;
  const params = { includes };
  const { status, data } = await userResource.user(id).update(payload, params);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Updating of User failed.');
});

export const deleteUser = createAsyncThunk('organization/deleteUser', async (initialData, { rejectWithValue }) => {
  const userResource = new UsersServiceResource();
  const { id } = initialData;
  const { status } = await userResource.user(id).delete();
  if (status === 202) {
    return id;
  }
  return rejectWithValue('Deleting of User failed.');
});

export const assignAdmin = createAsyncThunk('organization/assignAdmin', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { orgId, userId, includes = 'admins' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(orgId).assignAdmin(userId, params);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Assigning of admin failed.');
});

export const unassignAdmin = createAsyncThunk(
  'organization/unassignAdmin',
  async (initialData, { rejectWithValue }) => {
    const organizationResource = new OrganizationsResource();
    const { orgId, userId, includes = 'admins' } = initialData;
    const params = { includes };
    const { status, data } = await organizationResource.organization(orgId).unassignAdmin(userId, params);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Unassigning of admin failed.');
  }
);

export const addMember = createAsyncThunk('organization/addMember', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { orgId, userId, includes = 'organisation' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(orgId).addMember(userId, params);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Adding of member failed.');
});

export const removeMember = createAsyncThunk('organization/removeMember', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { orgId, userId, includes = 'organisation' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(orgId).removeMember(userId, params);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Removing of member failed.');
});
